var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _vm.languages
                        ? _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("languages"))),
                              ]),
                              _c(
                                "w-sortable",
                                {
                                  attrs: {
                                    items: _vm.languages.LanguageNames,
                                    tag: "w-list",
                                    "disable-x": "",
                                    "target-class": "handle",
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.languages.LanguageNames,
                                    function (lang, i) {
                                      return _c(
                                        "w-list-item",
                                        {
                                          key: i,
                                          attrs: { "show-handle": "" },
                                        },
                                        [
                                          _c("w-list-item-text", [
                                            _vm._v(
                                              _vm._s(_vm.getLanguageName(lang))
                                            ),
                                          ]),
                                          _c(
                                            "w-list-item-action",
                                            [
                                              _c(
                                                "w-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        _vm.$ct(
                                                          "common.delete"
                                                        ),
                                                      expression:
                                                        "$ct('common.delete')",
                                                    },
                                                  ],
                                                  staticClass: "danger",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeLangClicked(
                                                        i
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("w-fa", {
                                                    attrs: { icon: "trash" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c(
                                    "w-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.addLangModal = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "w-list-item-icon",
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "plus" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("w-list-item-text", [
                                        _vm._v(
                                          " " + _vm._s(_vm.$ct("add-language"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("interface-language"))),
                          ]),
                          _c(
                            "w-list",
                            [
                              _c(
                                "w-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.setInterfaceLanguage("nl-be")
                                    },
                                  },
                                },
                                [_vm._v("Nederlands")]
                              ),
                              _c(
                                "w-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.setInterfaceLanguage("fr")
                                    },
                                  },
                                },
                                [_vm._v("Français")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    {
                      model: {
                        value: _vm.addLangModal,
                        callback: function ($$v) {
                          _vm.addLangModal = $$v
                        },
                        expression: "addLangModal",
                      },
                    },
                    [
                      _c("app-add-language-modal", {
                        attrs: { languages: _vm.languages },
                        on: {
                          close: function ($event) {
                            _vm.addLangModal = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }